'use client';

import React, { FC, useEffect, useRef } from 'react';
import { Box, BoxProps, Paper } from '@mantine/core';

const VideoBlock: FC<{
    video: {
        src: string;
        width?: number;
        height?: number;
        playbackRate?: number;
        controls?: boolean;
        autoPlay?: boolean;
    };
    wrapperProps?: BoxProps;
}> = ({ video, wrapperProps }) => {
    const ref = useRef<HTMLVideoElement | null>(null);

    useEffect(() => {
        if (ref.current && video.playbackRate) {
            ref.current.playbackRate = video.playbackRate;
        }
    }, [video.playbackRate]);

    const handleFullscreen = () => {
        if (ref.current) {
            if (ref.current.requestFullscreen) {
                ref.current.requestFullscreen();
            }
        }
    };

    const showControls = video.controls ?? false;
    const shouldAutoPlay = video.autoPlay ?? true;

    return (
        <Paper
            radius="md"
            shadow="md"
            style={{
                overflow: 'hidden',
                cursor: showControls ? 'default' : 'pointer',
                border: '1px solid var(--mantine-color-gray-2)',
            }}
            {...wrapperProps}
        >
            <Box
                component="video"
                style={{ display: 'block', width: '100%', height: 'auto' }}
                autoPlay={shouldAutoPlay}
                playsInline
                loop
                muted
                controls={showControls}
                controlsList="nodownload"
                ref={ref}
                onClick={showControls ? undefined : handleFullscreen}
            >
                <source src={video.src} type="video/mp4" />
            </Box>
        </Paper>
    );
};

export { VideoBlock };
